
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "createPipeline",
      resolverType: "mutation",
      routePath: "/createPipeline",
      httpMethod: "POST",
    });
  